import {IconDefinition} from "@fortawesome/free-solid-svg-icons";
import {FC, ReactNode, useState} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

export interface TabContainerPage {
  name: string
  icon: IconDefinition
  countBubble?: number
  body: ReactNode
  showContainer?: boolean
}

interface TabContainerProps {
  title: string
  tabs: TabContainerPage[]
}
export const TabContainer: FC<TabContainerProps> = props => {
  const [currentTab, setCurrentTab] = useState(0)

  const currentTabPage: TabContainerPage|undefined = props.tabs[currentTab]

  return <div>
    <div className={'sticky top-0 bg-slate-50 z-20'}>
      <nav className={'flex items-end bg-slate-50 px-1'}>
        <h1 className={'flex items-center text-lg font-bold pr-8 h-12 flex items-center justify-center'}>{props.title}</h1>
        {props.tabs.map((tab, i) => {
          return <div key={i} className={`${i === currentTab ? 'border-white border-b -mb-px' : 'border-transparent border-b'}`}>
            <button className={`flex items-center font-medium ${i === currentTab ? 'text-blue-800 rounded-t-lg border-l border-t border-r bg-white border-slate-200' : 'text-slate-700'} px-4 h-12`} onClick={() => setCurrentTab(i)}>
              <FontAwesomeIcon icon={tab.icon} />
              <div className={'mx-3'}>{tab.name}</div>
              {tab.countBubble !== undefined ? <>
                <div className={'bg-blue-100 text-blue-900 text-xs font-bold px-2 h-5 flex items-center justify-center rounded-full mr-1'}>{tab.countBubble}</div>
              </> : <></>}
            </button>
          </div>
        })}
      </nav>
      <div className={`${currentTabPage.showContainer === false ? '' : 'h-1 border-t border-l border-r rounded-t border-slate-200 bg-white'} `}></div>
    </div>
    <main className={`${currentTabPage.showContainer === false ? '' : 'py-3 px-4 border-l border-b border-r rounded-b border-slate-200 bg-white'}`}>
      {currentTabPage === undefined ? <div></div> : currentTabPage.body}
    </main>
  </div>
}